import React from 'react';
import { generatePath, useHistory } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import {
  ROUTE_PACIENTES_EDIT, ROUTE_PACIENTES_EYECHART_NEW, ROUTE_PACIENTES_GDPR, ROUTE_PACIENTES_CONTACTOLOGY_NEW,
} from '../../../../routes.constants';
import ActionsHeader, {NAVIGATION_ANCHOR} from '../../../shared/containers/ActionsHeader';
import { downloadPacienteUrlRgpd, openPacienteUrlRgpd, downloadPacienteUrlAwsRgpd, openPacienteUrlAwsRgpd } from '../../../../state/actions/creators/pacientes.actioncreator';


function NavBar({
  pacienteSelected, grpd,
}:any) {
  const appNavigation = useSelector((state: any) => state.app.navigation);
  const dispatch = useDispatch();
  const { rgpd_tipo_firma } = pacienteSelected;
  const downloadGRPD = () => {
    if(rgpd_tipo_firma === 1){
      dispatch(downloadPacienteUrlRgpd(pacienteSelected.id));
    } else if(rgpd_tipo_firma === 2){
      dispatch(downloadPacienteUrlAwsRgpd(pacienteSelected.id));
    } 
  };
  const openRgpd = () => {
    if(rgpd_tipo_firma === 1){
      dispatch(openPacienteUrlRgpd(pacienteSelected.id));
    } else if(rgpd_tipo_firma === 2){
      dispatch(openPacienteUrlAwsRgpd(pacienteSelected.id));
    }
  };
  const history = useHistory();
  const headerData = [
    {
      translationId: 'pacientes.client_file.edit',
      text: 'Editar',
      onClick: () => history.push(generatePath(ROUTE_PACIENTES_EDIT, { pacienteId: pacienteSelected.id })),
    },
    {
      translationId: 'pacientes.client_file.new_test',
      text: 'Graduaciones',
      children: [
        {
          translationId: 'pacientes.client_file.optometry',
          text: 'Optometría',
          onClick: () => history.push(generatePath(ROUTE_PACIENTES_EYECHART_NEW, { pacienteId: pacienteSelected.id })),
        },
        {
          translationId: 'pacientes.client_file.contactology',
          text: 'Contactología',
          onClick: () => history.push(generatePath(ROUTE_PACIENTES_CONTACTOLOGY_NEW, { pacienteId: pacienteSelected.id })),
        },
      ],
    },
    {
      translationId: 'pacientes.client_file.gdpr',
      text: 'RGPD',
      children: [
        {
          translationId: 'pacientes.client_file.sign',
          text: 'Firmar',
          onClick: () => history.push(generatePath(ROUTE_PACIENTES_GDPR, { pacienteId: pacienteSelected.id })),
        },
        {
          translationId: 'pacientes.client_file.print',
          text: 'Imprimir',
          onClick: () => openRgpd(),
          visible: rgpd_tipo_firma !== 0,
        },
        {
          translationId: 'pacientes.client_file.download',
          text: 'Descargar',
          visible: rgpd_tipo_firma !== 0,
          onClick: () => downloadGRPD(),
        },
      ],
    },
  ];
  return (
    <ActionsHeader anchor={NAVIGATION_ANCHOR} sticky data={headerData} />
  );
}
export default injectIntl(NavBar);
